import React from 'react';

const ScoreABw = (props) => (
    <svg viewBox="0 0 59.53 59.53" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient
          id="A_bw_svg__a"
          x1={361.95}
          y1={29.76}
          x2={2.83}
          y2={29.76}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#222" />
          <stop offset={1} stopColor="#ababab" />
        </linearGradient>
      </defs>
      <g data-name="Vrstva 2">
        <circle
          cx={29.76}
          cy={29.76}
          r={29.76}
          style={{
            fill: "url(#A_bw_svg__a)",
          }}
        />
        <path
          d="m37.62 43-2.23-6.57H24.2L22 43h-7l10.8-27.7h8L44.63 43Zm-3.78-11.45q-3.09-8.93-3.48-10.11c-.25-.78-.44-1.39-.55-1.85q-.69 2.41-4 12Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
    </svg>
  );
  
  export default ScoreABw;